import { syntaxFNMA } from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { useMemo } from 'react';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  getAloftPriceJSONPropertyGridField,
  getNumberPropertyGridField,
  suffixField,
} from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridFieldName,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const RentalFeatureGridTransactionSection = (props: PropertyGridSectionProps) => {
  const fields = useMemo(
    () => [
      {
        fieldName: 'editableData.transaction.status' as PropertyGridFieldName,
        label: 'Status',
        options: toOpts(['Active', 'Contract', 'Rented']),
        includeEmptyOption: true,
        toValue: (value?: string) => {
          if (!value) return undefined;
          if (value === 'Rented') return 'SettledSale';
          return value;
        },
        toDisplayValue: (value?: string) => {
          if (!value) return undefined;
          if (value === 'SettledSale') return 'Rented';
          return value;
        },
      },
      getAloftPriceJSONPropertyGridField({
        fieldName: 'editableData.transaction.rentRate',
        label: 'Rent Rate',
      }),
      {
        fieldName: 'editableData.transaction.leaseDate' as PropertyGridFieldName,
        label: 'Lease Date',
        tooltipContent:
          'If the lease date was obtained from a source outside the MLS, the displayed date may reflect when the rental listing was withdrawn rather than the actual lease execution date.',
        toDisplayValue: (isoMonth?: string) => {
          if (!isoMonth) return undefined;
          try {
            const date = syntaxFNMA.isoMonthToAloftDate(isoMonth as syntaxFNMA.IsoMonth);
            return date.format('yyyy-MM');
          } catch {
            return isoMonth;
          }
        },
      },
      suffixField(
        getNumberPropertyGridField({
          fieldName: 'editableData.transaction.daysOnMarket',
          label: 'CDOM',
        }),
        'day',
        'days',
      ),
    ],
    [],
  );

  return <PropertyGridSection {...props} title="Transaction" fields={fields} />;
};
